import { getUrlParam } from '@/libs/functions/getValue'
import {
  transLangKeysForBoss,
  transLangKeysForStandard,
} from '@/libs/functions/lang'
import { LangStore } from './LangStore'

export function getLocaleByLocal() {
  const localeFromUmiLocal = localStorage.getItem('umi_locale')
  const localeFromBossLocal = sessionStorage.getItem('lg')
  const locale = localeFromUmiLocal || localeFromBossLocal || ''
  const supportLangs = LangStore.getSupportLangs()

  // 标准化语言代码
  const standardLocale = transLangKeysForStandard(locale)

  // 如果标准化后的语言不在支持列表中，使用默认语言
  const finalLocale = supportLangs.includes(standardLocale)
    ? standardLocale
    : supportLangs[0]

  return {
    // 非标
    bossLocale: transLangKeysForBoss(finalLocale),
    // Saas 标准化语种
    locale: finalLocale,
  }
}
